import React from 'react'
import { I18n } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Grid } from '@mui/material'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const Equipment = props =>
  <Box sx={{ p: 2 }}>
    <Grid container justifyContent='center'>
      <Grid size={11}>
        <SearchFrame
          model_name={'equipment'}
          allowCreate
          createButtonProps={{ label: I18n.t('equipment.add') }}
        >
          <SearchForm submitOnMount >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable>
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Grid>
    </Grid>
  </Box>


export default React.memo(Equipment)
